import { Controller } from "@hotwired/stimulus";


export default class extends Controller {
  static targets = ["banner"]

  connect() {
    this.lastScrollTop = window.scrollY || 0;
    this.handleScroll();
  }

  handleScroll() {
    const currentScroll = window.scrollY || 0;

    if (currentScroll <= 120) {
      this.showBanner();
    } else if (currentScroll > this.lastScrollTop) {
      this.hideBanner();
    }

    this.lastScrollTop = currentScroll;
  }

  hideBanner() {
    this.bannerTarget.classList.remove("vc-news-banner--visible");
    this.bannerTarget.classList.add("vc-news-banner--hidden");
  }

  showBanner() {
    this.bannerTarget.classList.add("vc-news-banner--visible");
    this.bannerTarget.classList.remove("vc-news-banner--hidden");
  }
}
